function initHeroSound() {
  document.querySelectorAll('.ndg-hero-film__sound').forEach( btn => {
    const wrap    = btn.closest('.ndg-hero-film');
    const videoEl = wrap?.querySelector('.ndg-hero-film__video');
    const ytFrame = wrap?.querySelector('.ndg-hero-film__yt-bg');
    let   isMuted = true;

    btn.addEventListener('click', () => {
      isMuted = ! isMuted;
      btn.classList.toggle('is-unmuted', ! isMuted);

      if ( videoEl ) {
        videoEl.muted = isMuted;
      } else if ( ytFrame ) {
        ytFrame.contentWindow?.postMessage(
          JSON.stringify({ event: 'command', func: isMuted ? 'mute' : 'unMute' }), '*'
        );
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initHeroSound);
